const SITE_BASE_URL = process.env.REACT_APP_SITE_BASE_URL || 'http://127.0.0.1:8000';
const API_BASE_URL = `${SITE_BASE_URL}/api`;
const FILE_BASE_URL = `${SITE_BASE_URL}/files`;
const LOGO_BASE_URL = `${SITE_BASE_URL}/logo`;
const PLAYER_BASE_URL = `${SITE_BASE_URL}/players`;

export { SITE_BASE_URL, API_BASE_URL, FILE_BASE_URL, LOGO_BASE_URL, PLAYER_BASE_URL };
